import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";

const TableSettings = ({ title, items }) => {
  return (
    <div>
      <Menu as="div" className="relative inline-block">
        <div>
          <Menu.Button className="inline-flex justify-center w-full px-4 py-2 text-sm rounded-md">
            {title}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="z-20 absolute right-0 w-56 mt-5 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="p-3">
              <h3 className="text-sm">Table Settings</h3>
            </div>
            {items.map((item, key) => (
              <div key={key} className="p-1">
                {item.content}
              </div>
            ))}
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default TableSettings;
